import React from "react";

import { Button, Typography } from "@material-ui/core";

import SvgI24Details from "assets/icons/I24Details";
import SvgI24Edit from "assets/icons/I24Edit";

import TrimmedText from "components/TrimmedText";
import PublishStatus from "components/PublishStatus";

import {
  getPublishButtonIcon,
  getPublishButtonTextWithout,
} from "utils/publish";

import {
  Container,
  ImageContainer,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  BottomControlsContainer,
  ControlWrapper,
  StatusContainer,
  StatusWrapper,
} from "./styles";

type Props = {
  title: string;
  image: string;
  publishStatus: string;
  onDetailsClick: () => void;
  onEdit: () => void;
  onPublish: () => void;
};

class CoachCard extends React.Component<Props> {
  render() {
    const {
      title,
      image,
      publishStatus,
      onDetailsClick,
      onEdit,
      onPublish,
    } = this.props;

    return (
      <Container>
        <ImageContainer image={image} />
        <DetailsContainer>
          <TextContainer>
            <TitleWrapper>
              <TrimmedText lines={1} text={title}>
                <Typography variant="h3" color="textPrimary">
                  {title}
                </Typography>
              </TrimmedText>
            </TitleWrapper>
          </TextContainer>
          <BottomControlsContainer>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Details />}
                variant="text"
                color="secondary"
                onClick={onDetailsClick}
              >
                Details
              </Button>
            </ControlWrapper>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Edit />}
                variant="text"
                color="secondary"
                onClick={onEdit}
              >
                Edit
              </Button>
            </ControlWrapper>
            <ControlWrapper isPublishControl>
              <Button
                startIcon={getPublishButtonIcon(publishStatus)}
                variant="text"
                color="secondary"
                onClick={onPublish}
              >
                {getPublishButtonTextWithout(publishStatus)}
              </Button>
            </ControlWrapper>
          </BottomControlsContainer>
        </DetailsContainer>
        <StatusContainer>
          <StatusWrapper>
            <PublishStatus status={publishStatus} />
          </StatusWrapper>
        </StatusContainer>
      </Container>
    );
  }
}

export default CoachCard;
